export default {
  methods: {
    isGuestPage() {
      const arr = ['Login']
      return arr.indexOf(this.$route.name) !== -1
    },
  }
}
